module.exports = __webpack_public_path__ + "img/red-unchecked-tick.1af09083.svg";